import { useIntl } from "react-intl"
import { useRef, useState, useEffect } from "react"
import { Combobox, CustomTable, InputDate, Modal } from "medere-ui-framework"
import { getPatientTransferOrderList, getSectors, getPriorities, getSectorById, savePatientTransfer, cancelPatientTransfer, getBeds, getBedById, sendTokenToServer, hasATransferOrder, getRelatedPendingProgressPatientTransfers, isAllowedToAssignTransfers } from "../servicesHooks/Transfer/useTransferService"
import { Column } from "primereact/column"
import { format, parseISO } from 'date-fns';
import { Button } from "primereact/button"
import { Checkbox } from 'primereact/checkbox';
import { Toast, ToastMessage } from 'primereact/toast';
import { TransferStatus, CancellationReason } from "./StretcherBearerView";
import { getToken, onMessage } from "firebase/messaging";
import { messaging, onMessageListener } from "../App";
import { TimeField } from '@mui/x-date-pickers/TimeField';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TransferRequestCard } from "../components/InfoCard/TransferRequestCard";

// Los hooks de cada fila viven en su propio componente: llamarlos dentro del `body` de una Column
// los cuelga del componente de la tabla y, al cambiar la cantidad de filas, React tira el error #300.
function useHasTransferOrder(medereentity: number) {
  const [hasTransferOrder, setHasTransferOrder] = useState(false)
  useEffect(() => {
    let active = true
    hasATransferOrder(medereentity).then((response) => {
      if (active) setHasTransferOrder(response.statusCode == 200)
    })
    return () => { active = false }
  }, [medereentity])
  return hasTransferOrder
}

function TransferDetailsCell({ medereentity, onOpenDetails }: { medereentity: number, onOpenDetails: () => void }) {
  const hasTransferOrder = useHasTransferOrder(medereentity)
  const buttonStyle = {
    height: '23px',
    color: '#14C7BC',
    backgroundColor: 'transparent',
    border: 'none',
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        visible={hasTransferOrder}
        onClick={() => hasTransferOrder ? onOpenDetails() : ''}
        icon='pi pi-ellipsis-v'
        iconPos="left"
        style={buttonStyle}
      />
    </div>
  );
}

function TransferRequestCell({ medereentity, onRequest }: { medereentity: number, onRequest: () => void }) {
  const intl = useIntl();
  const hasTransferOrder = useHasTransferOrder(medereentity)
  const buttonStyle = {
    width: hasTransferOrder ? '142px' : '128px',
    height: '23px',
    color: '#14C7BC',
    backgroundColor: 'transparent',
    border: 'none',
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        onClick={() => hasTransferOrder ? '' : onRequest()}
        style={buttonStyle}
      >
        <span className={`${hasTransferOrder ? 'color585A5F' : ''}`} style={{ marginLeft: '20px', fontWeight: 600 }}>
          {hasTransferOrder ? intl.formatMessage({ id: 'Requested' }) : intl.formatMessage({ id: 'Request' })}
        </span>
      </Button>
    </div>
  );
}

export default function TransferOrderView() {
  /* const vapidKey: string | null = searchParams.get('vapidKey'); */
  const intl = useIntl();
  const [vapidKey, setVapidKey] = useState<string | undefined>();
  const [userId, setUserId] = useState<number>(0);
  useEffect(() => {
    //TODO maxi: traer los datos de la API
    setVapidKey('');
    setUserId(-1);
  }, []);

  const [selectedSector, setSelectedSector] = useState<any>(null)
  const queryRefFinished: any = useRef(null)
  const toast = useRef(null);
  const [fromDate, setFromDate] = useState(generateFromDate())
  const todayDate = new Date()
  const maxDate = new Date(todayDate);
  maxDate.setDate(maxDate.getDate() + 1);
  const [open, setOpen] = useState(false)
  const [keyRoomBed, setKeyRoomBed] = useState(0);
  const [selectedCurrentSector, setSelectedCurrentSector] = useState<any>({ name: "", beds: 1 });
  const [selectedNewSector, setSelectedNewSector] = useState<any>({ name: "", beds: 1 });
  const [patientName, setPatientName] = useState('');
  const [conveyance, setConveyance] = useState(intl.formatMessage({ id: 'Wheelchair' }));
  const [oxygen, setOxygen] = useState(false);
  const [observations, setObservations] = useState<string>("");
  const initialBed: Bed = {
    bed: 0, room: 0, bednumber: '', roomnumber: '', roomandbed: ''
  }
  const [selectedCurrentBed, setSelectedCurrentBed] = useState<Bed>(initialBed);
  const [selectedDestinyBed, setSelectedDestinyBed] = useState<Bed>(initialBed);
  const [patientTransfer, setPatientTransfer] = useState<number>();
  const initialPriority: Priority = {
    priorityI18n: 2,
    description: "Normal",
    priority: 2
  };
  const [selectedPriority, setPriority] = useState<Priority>(initialPriority);
  const [selectedMedereentity, setMedereentity] = useState<number>();
  const [errorPri, setErrorPri] = useState(false);
  const [errorNewSec, setErrorNewSec] = useState(false);
  const [cancelTransferOrderConfirmation, setCancelTransferOrderConfirmation] = useState(false);
  const [recordStatus, setRecordStatus] = useState<number>();
  const [cancellationReason, setCancellationReason] = useState<string>('');
  const [cancellationReasonDescription, setCancellationReasonDescription] = useState<string>();
  const [insertedCancellationReasonDescription, setInsertedCancellationReasonDescription] = useState<string>('');
  const [clinicHistory, setClinicHistory] = useState('');
  const defaultTime = dayjs().subtract(4, 'hour');
  const [fromTime, setFromTime] = useState(defaultTime);
  const [fromHour, setFromHour] = useState("0");
  const [fromMinute, setFromMinute] = useState("0");
  const ConveyanceOptions = [
    { label: intl.formatMessage({ id: 'Wheelchair' }) },
    { label: intl.formatMessage({ id: 'Stretcher' }) },
    { label: intl.formatMessage({ id: 'Bed' }) },
  ];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedTransferRequest, setSelectedTransferRequest] = useState<PatientTransferDTO>();
  const [openDetailsWindow, setOpenDetailsWindow] = useState(false)
  const [isNotificationDisabled, setIsNotificationDisabled] = useState(false);
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [userAllowedToAssignUnassign, setUserAllowedToAssignUnassign] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const protocolo = window.location.protocol;
  const dominio = window.location.hostname;
  const urlBase = `${protocolo}//${dominio}`;

  onMessageListener()
    .then((payload) => {
      console.log('onMessage received. ', payload);
      queryRefFinished.current.refreshTable();
    }).catch((err) => console.log('failed: ', err));

  onMessage(messaging, (payload) => {
    console.log("onMessage received, payload: ", payload)
    queryRefFinished.current.refreshTable();
  });

  useEffect(() => {
    navigator.serviceWorker.register(`${urlBase}/firebase/firebase-messaging-sw.js`)
      .then((registration) => {
        console.log("se registro el service worker", registration)
        requestNotificationPermission(registration)
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
    /*navigator.serviceWorker.register(`/firebase-messaging-sw.js`)
    .then((registration) => {
        console.log("se registro el service worker", registration)
        requestNotificationPermission(registration)
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });*/
  }, []);

  function requestNotificationPermission(registration: ServiceWorkerRegistration) {
    console.log('Requesting permission...');
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted.');
        getTokenAndSendToServer(registration);
      } else {
        console.log('El usuario denegó el permiso para notificaciones.');
        setIsNotificationDisabled(true)
      }
    })
  }
  function getTokenAndSendToServer(registration: ServiceWorkerRegistration) {
    getToken(messaging, { vapidKey: vapidKey, serviceWorkerRegistration: registration }).then((currentToken) => {
      if (currentToken) {
        sendTokenToServer(currentToken)
          .then((msgError) => {
            if (msgError.statusCode == 208) {
              showMessage("Error al guardar el token", toast, 'error')
            } else {
              console.log("Se guardo el token")
            }
          })
          .catch(error => {
            console.error('Error al guardar los datos:', error);
          }).finally(() => {
            queryRefFinished.current.refreshTable();
          })
      } else {
        console.log('No registration token available. Request permission to generate one.');
        showMessage("No registration token available. Request permission to generate one.", toast, 'error')
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
  }

  const showMessage = (msg: any, ref: React.RefObject<Toast>, severity: ToastMessage['severity']) => {
    ref.current?.show({ severity: severity, summary: msg, life: 3000 });
  };

  type PatientTransferDTO = { patienttransfer: number, relatedpatienttransfer: number, fullname: string, newsector: number, currentsector: number, conveyance: string, oxygen: boolean, medereentity: number, currentstatus: number, transfertodate: Date, frombed: number, tobed: number, comments: string, cancellationreason: number, cancellationreasondescription: string, clinichistoryid: string, _user: number }
  type Priority = { priorityI18n: number, description: string, priority: number }
  type Bed = { bed: number, room: number, bednumber: string, roomnumber: string, roomandbed: string }

  function handleClick(record: PatientTransferDTO) {
    const { patienttransfer, fullname, newsector, currentsector, conveyance, oxygen, medereentity, frombed, tobed, currentstatus, cancellationreason, cancellationreasondescription, clinichistoryid } = record
    setPatientTransfer(patienttransfer)
    setPatientName(fullname)
    setMedereentity(medereentity)
    setClinicHistory(clinichistoryid)
    getSectorById(currentsector).then((response) => { //currentsector seria el nuevo sector destino
      setSelectedNewSector(response)
      console.log("currentsector asignado a selectedNewSector", response)

    })
    getSectorById(newsector).then((response) => { //newsector seria el nuevo sector origen
      setSelectedCurrentSector(response)
      console.log("newsector asignado a selectedCurrentSector", response)

    })

    if (tobed != null) { //tobed seria la nueva cama origen
      getBedById(newsector, tobed).then((response) => {
        setSelectedCurrentBed(response)
      })
    } else {
      setSelectedCurrentBed(initialBed)
    }

    if (frombed != null) { //tobed seria la nueva cama origen
      getBedById(currentsector, frombed).then((response) => {
        setSelectedDestinyBed(response)
      })
    } else {
      setSelectedDestinyBed(initialBed)
    }

    setRecordStatus(currentstatus)
    setObservations("")
    setCancellationReason(getCancelReasonMessage(cancellationreason))
    setCancellationReasonDescription(cancellationreasondescription)
    setConveyance(conveyance)
    setOxygen(oxygen)
    setOpen(true);
    setErrorPri(false)
    setErrorNewSec(false)
    console.log(errorNewSec)

  }

  useEffect(() => {
    setSelectedDestinyBed(initialBed)
    setSelectedCurrentBed(initialBed)
  }, [open]);

  function handleCancellationReasonChange(event: any) {
    setInsertedCancellationReasonDescription(event.target.value);
  }

  const getCancelReasonMessage = (cancellationReason: number) => {
    switch (cancellationReason) {
      case CancellationReason.PATIENTNOTINCONDITIONS:
        return intl.formatMessage({ id: 'PatientNotInConditions' });

      case CancellationReason.PATIENTNOTFOUND:
        return intl.formatMessage({ id: 'PatientNotFound' });

      case CancellationReason.ADMINISTRATIVEERROR:
        return intl.formatMessage({ id: 'AdministrativeError' });

      case CancellationReason.CANCELLEDBYSOLICITANT:
        return intl.formatMessage({ id: 'CancelledBySolicitant' });

      case CancellationReason.NECESSARYEQUIPMENTNOTAVAILABLE:
        return intl.formatMessage({ id: 'NecessaryEquipmentNotAvailable' });

      case CancellationReason.PATIENTREFUSED:
        return intl.formatMessage({ id: 'PatientRefused' });

      case CancellationReason.OTHERREASONS:
        return intl.formatMessage({ id: 'OtherReasons' });

      default:
        return '';
    }
  };

  function handleClickDetails(record: PatientTransferDTO) {
    setPatientTransfer(record.patienttransfer);
    setMedereentity(record.medereentity)

    if (patientTransfer) {
      getRelatedPendingProgressPatientTransfers(patientTransfer).then((response: PatientTransferDTO) => {
        setSelectedTransferRequest(response)
      })
      setOpenDetailsWindow(true)
    } else {
      console.log("patientTransfer undefined in handleClickDetails")
    }
  }

  function handleObservationsChange(event: any) {
    const newValue = event.target.value;
    setObservations(newValue);
  }

  const handleSectorChange = (newSector: any) => {
    setSelectedNewSector(newSector);
    setSelectedDestinyBed(initialBed)
    setKeyRoomBed((prevKey) => prevKey + 1);  //para que aparezcan en el combobox de camas, las camas correspondientes al sector actual elegido
  };

  const handleFromTimeChange = (newTime: any) => {
    setFromTime(newTime);
    setFromHour(newTime.hour());
    setFromMinute(newTime.minute());
  };

  const handleConveyanceChange = ({ label: newConveyance }: any) => {
    setConveyance(newConveyance);
  };

  useEffect(() => {
    queryRefFinished.current.refreshTable();
  }, [selectedSector]);

  useEffect(() => {
    isAllowedToAssignTransfers(59).then((response) => {   //59 es el MenuItemAction que permite asignar y desasignar camilleros a traslados
      setUserAllowedToAssignUnassign(response.statusCode == 200 ? true : false)
    })
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function generateFromDate() {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();

    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

    return new Date(formattedDate);
  }

  function save() {
    setDisabled(true)
    if (!selectedPriority) {
      setErrorPri(true)
    }
    if (!selectedNewSector) {
      setErrorNewSec(true)
    }
    if (selectedMedereentity && selectedPriority && patientTransfer) {
      const currentsectorId = selectedCurrentSector.sector
      const newsectorId = selectedNewSector.sector
      const priorityId = selectedPriority.priorityI18n

      savePatientTransfer(patientTransfer, selectedMedereentity, currentsectorId, newsectorId, oxygen, conveyance, priorityId, observations, selectedCurrentBed?.bed ? Number(selectedCurrentBed.bed) : -1, selectedDestinyBed?.bed ? Number(selectedDestinyBed.bed) : -1)
        .then((msgError) => {
          if (msgError.statusCode == 208) {
            showMessage(intl.formatMessage({ id: "ThereIsAlreadyATransferOrderRequestedForThisPatient" }), toast, 'error')
          } else {
            showMessage(intl.formatMessage({ id: "TransferRequested" }), toast, 'success')
          }
          setOpen(false);
        })
        .catch(error => {
          console.error('Error al guardar los datos:', error);
        }).finally(() => {
          queryRefFinished.current.refreshTable();
          setDisabled(false)
        })

    } else {
      console.error('Medereentity or Priority undefined');
    }

  }

  function cancelTransferOrder() {
    if (selectedMedereentity && userId) {
      cancelPatientTransfer(selectedMedereentity, TransferStatus.PENDING, CancellationReason.CANCELLEDBYSOLICITANT, insertedCancellationReasonDescription)
        .then((msgError) => {
          if (msgError.statusCode == 208) {
            showMessage(intl.formatMessage({ id: "TransferAlreadyInProgress" }), toast, 'error')
          } else {
            showMessage(intl.formatMessage({ id: "TransferCancelled" }), toast, 'success')
          }
          setCancelTransferOrderConfirmation(false);
          setOpenDetailsWindow(false)
          setInsertedCancellationReasonDescription('')
        })
        .catch(error => {
          showMessage("Error", toast, 'error')
          console.error('Error al guardar los datos:', error);
        })
    } else {
      console.error('pattienttransfer, userId or medereentity undefined');
      console.log("medereentity: ", selectedMedereentity, ", userId: ", userId)
    }
  }

  return (
    <div className="m-4 h-96 viewContainer">
      <h2 style={{ color: '#B67345', fontWeight: 600 }} className="text-2xl">{intl.formatMessage({ id: 'Patients' })} / {intl.formatMessage({ id: 'ReturnOfPatients' })}</h2>
      <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
        <Combobox label={intl.formatMessage({ id: 'DestinySector' })} getItems={getSectors} optionLabel='name' setValue={setSelectedSector} value={selectedSector} className="md:w-96" />
        <div className="flex md:gap-4 gap-2 w-full align-items-end flex-row md:flex-row">
          <InputDate label={intl.formatMessage({ id: 'Date' })} value={fromDate} onChange={(e: any) => setFromDate(e.value)} maxDate={todayDate} className={`${isMobile ? 'pb-0' : 'w-145'} mt-2.5`} />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimeField
              label={intl.formatMessage({ id: 'from' })}
              value={fromTime}
              onChange={handleFromTimeChange}
              format="HH:mm"  //agregando "HH:mm:ss" pone segundos, y agregando "HH:mm a" agrega AM/PM
              className='w-70 h-48'
              size="small"
            />
          </LocalizationProvider>
        </div>
      </div>

      <h3 style={{ fontSize: '18px', color: '#B67345', marginBottom: '10px', marginTop: '10px' }}>{intl.formatMessage({ id: 'Finisheds' })}</h3>
      <CustomTable filterRow idTable="tableFinished" hideFiltersButton getItems={selectedSector ? getPatientTransferOrderList : async () => Promise.resolve([])}
        showGridlines params={{
          sector: selectedSector ? selectedSector.sector : null,
          fromDate: fromDate,
          fromHour: fromHour != null ? Number(fromHour) : null,
          fromMinute: fromMinute != null ? Number(fromMinute) : null
        }} className="crudTable" ref={queryRefFinished} itemSize={30}>

        <Column
          field="openDetails"
          body={(record: PatientTransferDTO) => (
            <TransferDetailsCell medereentity={record.medereentity} onOpenDetails={() => handleClickDetails(record)} />
          )} className="columnSquare"
        />

        <Column
          field="openWindow"
          header={intl.formatMessage({ id: 'Return' })}
          body={(record: PatientTransferDTO) => (
            <TransferRequestCell medereentity={record.medereentity} onRequest={() => handleClick(record)} />
          )} className="columnBt"
        />
        <Column field="fullname" header={intl.formatMessage({ id: 'CH' }) + ' - ' + intl.formatMessage({ id: 'Patient' })} className="column columnGen"
          body={(record: PatientTransferDTO) => {
            return (
              <span style={{ marginLeft: '1px' }}>
                {record.clinichistoryid} - {record.fullname}
              </span>
            );
          }}
        />
        <Column field="transfertodate" header={intl.formatMessage({ id: 'Finished' })} className="columnDt columnGen" body={(x) => {
          return format(parseISO(x.transfertodate), 'dd/MM/yyyy HH:mm')
        }} />
        <Column field="namecurrentsector" header={intl.formatMessage({ id: 'Origin' })} className="column columnGen" />
        <Column field="namenewsector" header={intl.formatMessage({ id: 'Destiny' })} className="column columnGen" />
        <Column field="conveyance" header={intl.formatMessage({ id: 'conveyance' })} className="columnCvy columnGen" />
      </CustomTable>

      <Modal visible={open} setVisible={setOpen} header={<span style={{ fontSize: '22px' }}>{intl.formatMessage({ id: 'YouAreGoingToRequestThisReturn...' })}</span>}>
        {recordStatus == TransferStatus.FINISHED && (<div style={{ display: 'flex', flexDirection: 'column' }} className="p-m-4">

          <span style={{ color: 'black', fontWeight: 600, paddingBottom: '4px', borderBottom: '1px solid #BCBCBC', fontSize: '16px' }}>
            {clinicHistory} - {patientName}
          </span>

          <div style={{ borderBottom: '1px solid #BCBCBC' }} className="p-flex p-flex-md-row p-gap-2 p-gap-md-4 p-justify-between p-items-end">

            <div style={{ paddingBottom: '4px', paddingTop: '4px', borderBottom: '1px solid #BCBCBC', display: 'flex', marginTop: '4' }}>
              <div>
                <span style={{ marginTop: '5px', fontSize: '16px' }}> {intl.formatMessage({ id: 'Origin' })}:</span>
                <span style={{ marginLeft: '3px', marginTop: '5px', fontSize: '16px' }}>{selectedCurrentSector ? selectedCurrentSector.name : ''}</span>
              </div>

              {selectedCurrentSector != null && selectedCurrentSector.beds != null && selectedCurrentSector.beds > 0 && selectedCurrentBed?.roomandbed &&
                (<div >
                  {<span style={{ marginLeft: '3px', marginTop: '5px', fontSize: '14px' }}>{selectedCurrentBed ? <span>{intl.formatMessage({ id: 'Room' })}<span style={{ fontWeight: 600 }}>{' ' + selectedCurrentBed.roomnumber + ' - ' + intl.formatMessage({ id: 'Bed' }) + ' ' + selectedCurrentBed.bednumber}</span></span> : ''} </span>}
                </div>
                )}
            </div>

            <div style={{ paddingTop: '6px', paddingBottom: '2px' }}>
              <div style={{ justifyContent: 'space-between', display: isMobile ? '' : 'flex' }}>
                {!isMobile && (<span style={{ width: '92px', marginTop: '11px' }}>{intl.formatMessage({ id: 'Destiny' })}:</span>)}
                <div style={{ maxWidth: isMobile ? '' : '350px', minWidth: isMobile ? '' : '350px' }}>
                  <Combobox label={isMobile ? intl.formatMessage({ id: 'Destiny' }) : ''} getItems={getSectors} optionLabel='name' setValue={handleSectorChange} value={selectedNewSector} />
                </div>
              </div>

              {selectedNewSector != null && selectedNewSector.beds != null && selectedNewSector.beds > 0 && (<div style={{ justifyContent: 'space-between', display: isMobile ? '' : 'flex' }}>
                {!isMobile && (<span style={{ width: '92px', marginTop: '11px' }}>{intl.formatMessage({ id: 'Room' })}:</span>)}
                <div style={{ maxWidth: isMobile ? '' : '350px', minWidth: isMobile ? '' : '350px' }}>
                  <Combobox key={keyRoomBed} label={isMobile ? intl.formatMessage({ id: 'Room' }) + ' / ' + intl.formatMessage({ id: 'Bed' }) : ''} getItems={getBeds} params={{ sector: selectedNewSector ? selectedNewSector.sector : null }} optionLabel='roomandbed' setValue={setSelectedDestinyBed} value={selectedDestinyBed} />
                </div>
              </div>)}
            </div>

          </div>

          <div className="flex align-items-end" style={{ justifyContent: 'space-between', borderBottom: '1px solid #BCBCBC', paddingTop: '6px', paddingBottom: '3px', display: isMobile ? '' : 'flex', alignItems: 'baseline' }}>
            {!isMobile && (<span style={{ width: '92px', marginTop: '11px' }}>{intl.formatMessage({ id: 'conveyance' })}:</span>)}
            <div style={{ flex: '1', maxWidth: isMobile ? '' : '350px', minWidth: isMobile ? '' : '350px' }}>
              <Combobox
                label={isMobile ? intl.formatMessage({ id: 'conveyance' }) : ''}
                getItems={() => Promise.resolve(ConveyanceOptions)}
                optionLabel="label"
                setValue={handleConveyanceChange}
                value={conveyance}
              />
            </div>
          </div>

          <div className="gap-1" style={{ justifyContent: 'space-between', borderBottom: '1px solid #BCBCBC', paddingTop: '6px', paddingBottom: '3px', display: isMobile ? '' : 'flex', alignItems: 'baseline' }}>
            {!isMobile && (<span style={{ width: '92px', marginTop: '12px' }}>{intl.formatMessage({ id: 'Priority' })}:</span>)}
            <div style={{ flex: '1', maxWidth: isMobile ? '' : '350px', minWidth: isMobile ? '' : '350px' }}>
              <Combobox label={isMobile ? intl.formatMessage({ id: 'Priority' }) : ''} getItems={getPriorities} optionLabel='description' setValue={setPriority} value={selectedPriority} error={errorPri} caption={errorPri ? intl.formatMessage({ id: 'SelectPriority' }) : ""} />
            </div>
          </div>

          <div style={{ display: 'flex', paddingBottom: '6px', paddingTop: '6px', borderBottom: '1px solid #BCBCBC' }}>
            <Checkbox style={{ marginRight: '8px' }} checked={oxygen} onChange={() => setOxygen(!oxygen)} />
            {intl.formatMessage({ id: 'RequiresOxygen' })}
          </div>

          <div style={{ borderBottom: '1px solid #BCBCBC' }}>
            {<h1 style={{ marginTop: '10px', fontSize: '15px' }}>{intl.formatMessage({ id: 'Observations' })}</h1>}
            <textarea style={{ fontSize: '12px' }} className="observation-box" value={observations} onChange={handleObservationsChange} placeholder={intl.formatMessage({ id: 'WriteSomething...' })} />
          </div>

          <Button style={{ width: '95%', margin: 'auto', height: '38px' }} disabled={disabled} onClick={save} label={intl.formatMessage({ id: 'REQUESTRETURN' })} className='buttonMain' />
        </div>)}

        {recordStatus == TransferStatus.CANCELLED && (  //cancelados con fecha de fin son los anulados, cancelados sin fecha de fin son los cancelados por solicitante
          <div className="p-m-4">
            {cancellationReason && (<h2 style={{ marginLeft: '3px', marginTop: '5px', fontSize: '17px' }}>{intl.formatMessage({ id: 'CancellationReason' })}: {cancellationReason}</h2>)}
            {cancellationReasonDescription && (<h2 style={{ marginLeft: '3px', marginTop: '5px', fontSize: '17px' }}>{intl.formatMessage({ id: 'Description' })}:</h2>)}
            {cancellationReasonDescription && (<textarea className="comment-box" value={cancellationReasonDescription} />)}
            {!cancellationReason && (<h2 style={{ marginLeft: '3px', marginTop: '5px', fontSize: '17px' }}>{intl.formatMessage({ id: 'CancellationReason' })}: {intl.formatMessage({ id: 'CancelledBySolicitant' })}</h2>)}
          </div>
        )}
      </Modal>

      <Modal visible={cancelTransferOrderConfirmation} setVisible={setCancelTransferOrderConfirmation} header={intl.formatMessage({ id: 'CancelPatientTransfer' })}>
        <h1 style={{ marginBottom: '10px', fontSize: '24px' }}>{intl.formatMessage({ id: 'YouWantToCancelTheTransfer' })}</h1>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
          <textarea className="comment-box" value={insertedCancellationReasonDescription} onChange={handleCancellationReasonChange} placeholder={intl.formatMessage({ id: 'DetailTheCancellationReason' }) + ':'} />
          <Button className='buttonMain' onClick={() => cancelTransferOrder()}>{intl.formatMessage({ id: 'CancelPatientTransfer' })}</Button>
        </div>
      </Modal>

      <Modal visible={openDetailsWindow} setVisible={setOpenDetailsWindow} className="custom-modal" header={selectedTransferRequest?.currentstatus === TransferStatus.INPROGRESS ? <span> {intl.formatMessage({ id: 'TransferDetails' })} <span style={{ color: 'green' }}>{intl.formatMessage({ id: 'inProgress' })}</span></span> : intl.formatMessage({ id: 'TransferDetails' })}>
        <div className="flex flex-column align-items-center justify-content-center">

          {selectedTransferRequest && (<TransferRequestCard
            key={selectedTransferRequest.patienttransfer}
            record={selectedTransferRequest}
            userId={userId}
            details
          />)}

          <Button className='buttonMain btnCancel fontSizeFifteen' visible={userAllowedToAssignUnassign || selectedTransferRequest?._user == userId} onClick={() => setCancelTransferOrderConfirmation(true)} label={intl.formatMessage({ id: 'CancelPatientTransfer' })} />

        </div>
      </Modal>

      <Modal visible={isNotificationDisabled} setVisible={setIsNotificationDisabled} header={intl.formatMessage({ id: 'YouDontHaveNotificationsEnabled' })} onClickRightBtn={() => setIsNotificationDisabled(false)}>
        <div style={{ margin: '10px 0', fontSize: '16px', lineHeight: '1.5' }}>
          {intl.formatMessage({ id: 'WeAskYouTo' })}:
          <div style={{ margin: '20px', padding: '15px', border: '2px solid black' }}>
            {isAndroid && (<p>{intl.formatMessage({ id: 'OnYourAndroidDevice' })}:</p>)}
            {isIPhone && (<p>{intl.formatMessage({ id: 'OnYourIPhoneDevice' })}:</p>)}
            {(isAndroid || isIPhone) && (<ol style={{ marginLeft: '20px' }}>
              <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourDevice' })}</li>
              <li>2. {intl.formatMessage({ id: 'GoToNotifications' })}</li>
              <li>3. {intl.formatMessage({ id: 'EnableThemForYourNavigator' })}</li>
            </ol>)}
            <p>{intl.formatMessage({ id: 'IfProblemPersistTry' })}:</p>
            <ol style={{ marginLeft: '20px' }}>
              <li>1. {intl.formatMessage({ id: 'GoToSettingsOnYourNavigator' })}</li>
              <li>2. {intl.formatMessage({ id: 'GoToPrivacyAndSecurity->DeleteNavigationData' })}</li>
              <li>3. {intl.formatMessage({ id: 'DeleteYourCookiesOrCache' })}</li>
              <li>4. {intl.formatMessage({ id: 'TryVerifyingIfSomethingIsBlockingNotificationsInNavigatorOrDevice' })}</li>
              <li>5. {intl.formatMessage({ id: 'ToReceiveNotificationsWeRecommendDisablingIncognitoModeTryOpeningARegularTabToEnableNotificationPermissions' })}</li>
            </ol>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button className='buttonMain' style={{ marginRight: '10px' }} onClick={() => setIsNotificationDisabled(false)}>
            {intl.formatMessage({ id: 'Accept' })}
          </Button>
        </div>
      </Modal>

      <Toast ref={toast} position="bottom-right" />

    </div>
  )

}